module.exports = __webpack_public_path__ + "img/sales-force-logo.1b6ab7bb.svg";